import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import Modal, { ModalTrigger } from 'common/modal';
import { ELITE_SPOTS_TEXT, ELITE_TIPPED_SPOTS_TEXT } from 'project/constants';
import ReservationForm from 'project/containers/reservation_form';

const ReservationModal = ({ isReserved, isEliteWindowOpen, reservationWindowEnd }) => {
  if (isReserved) {
    return (
      <Modal header="Success!" id="elite-reservation-modal">
        <h3 className="text-center">
          <i className="fa fa-2x fa-check-circle text-success"/><br/>
          You&apos;ve requested your reservation!
        </h3>
        { isEliteWindowOpen?
        <p>
          The reservation window will close at {reservationWindowEnd} and when that happens, we
          will email you to let you know whether you received one of the spots. Please do not start
          working on this project until you hear from us.
        </p> :
        <p>
          We will send you an email within the next 30 minutes to let you know if you've been
          accepted to work in this project. Please do not start working on this project until
          you hear from us.
        </p> }
        <div className="modal-actions">
          <ModalTrigger className="btn btn-tertiary btn-block" trigger="elite-reservation-modal">
            Got it!
          </ModalTrigger>
        </div>
      </Modal>
    );
  }

  return (<Modal header="Before you submit..." id="elite-reservation-modal">
    <h1>This is an Elite project</h1>
    <p>
      Good news! This project is not yet full and you can request a reservation for one of
      the {ELITE_SPOTS_TEXT} spots. The reservation window will close at {reservationWindowEnd} and
      when that happens, we will email you to let you know whether you received one of the spots.
      Please do not start working on this project until you hear from us.
    </p>
    <p>
      Elite projects have <Link target="_blank" to="/help/working-in-projects/what-are-elite-projects/">
      special rules.</Link> There are only {ELITE_SPOTS_TEXT} participants. The winner receives the
      award (and is required to deliver final files in wrap-up) while the
      other {ELITE_TIPPED_SPOTS_TEXT} participants each receive a guaranteed tip (but since
      there's only one award, the tipped participants keep their intellectual property and have no
      wrap-up). By participating, you agree that:
    </p>
    <ol>
      <li>
        You will submit your <strong>very best, original</strong> work in this project.
        You may submit as many designs and revisions as you want, but you promise to submit at
        least 4 original designs in this project.
      </li>
      <li>
        You will carefully read the client&apos;s brief and submit designs that match the
        brief requirements. If you submit low quality designs, overused or overdone
        concepts, or stock art, you will lose Elite status and your account will be terminated.
      </li>
      <li>
        You do not need to submit something now to hold your place. However, you must click the
        Got It button below to request a reservation.
      </li>
      <li>
        You are not guaranteed a spot in this project. We will let you know by email
        at {reservationWindowEnd} whether you were given one of the {ELITE_SPOTS_TEXT} slots.
        Please do not begin work until you hear from us.
      </li>
      <li>
        Tips will be given based on the average client scores for the designs you submit in this
        project (highest average gets the biggest tip). In the event of ties, tips will be given based
        on the number of entries (and revisions) you submit in this project (highest number of entires
        gets the biggest tip). The person who receives the award will not receive a participation tip.
      </li>
      <li>
        You will uphold the crowdspring {' '}
        <Link target="_blank" to="/standards-of-conduct-creative">standards of conduct</Link>{' '}
        and professionally represent yourself and our community.
      </li>
    </ol>
    <ReservationForm />
  </Modal>);
};

ReservationModal.propTypes = {
  isReserved: PropTypes.bool,
  isEliteWindowOpen: PropTypes.bool,
  reservationWindowEnd: PropTypes.string.isRequired
};

ReservationModal.defaultProps = {
  isReserved: false,
};

export default ReservationModal;



// WEBPACK FOOTER //
// ./project/components/reservation_modal.jsx